(function () {
    'use strict';

    angular
        .module('app')
        .controller('ServerHealthController', ServerHealthController);

    ServerHealthController.$inject = ['API'];

    function ServerHealthController(API) {
        var vm = this;
        vm.report = null;
        vm.isLoading = false;

        activate();

        function activate() {
            loadServerHealth();
        }

        function loadServerHealth() {
            vm.isLoading = true;

            API.Statistic.get({ action: 'server-health' }).$promise.then(function (response) {
                vm.report = response;
                vm.isLoading = false;
            }, function () {
                vm.isLoading = false;
            });
        }


    }
})();